import Container from 'react-bootstrap/Container';
import { Helmet } from 'react-helmet-async';
import { Col, Row } from 'react-bootstrap';

const MissionScreen = () => {
  return (
    <Container className="">
      <Helmet>
        <title>Mission</title>
      </Helmet>

      <h1 className="my-3">Mission</h1>
      <hr />
      <Row>
        <Col md={5}>
          <section>
            <h3>Funds For Charity</h3>
            <p>Our primary purpose is really to raise as much funds as we can. The more funds we raise, the more people we can help.</p>
          </section>
          <section>
            <h3>Live With Charity</h3>
            <p>We envision charity donations to be part of our daily lives, not just something we do a number of times a year.</p>
          </section>
          <section>
            <h3>Getting Creative For Charity</h3>
            <p>Again, because we want charity donations to be part of our daily lives, we challenge ourselves to be creative for charity. We constantly think, how else can people help creatively? As soon as we fully develop a new idea, we launch it onsite.</p>
          </section>
        </Col>
        <Col md={7}>
          <img style={{height: "500px"}} src="/images/squidgames.jpg" className="img-fluid" />
        </Col>
      </Row>
      <section>
        <h3>Getting Involved With Charity</h3>
        <p>We don’t want you to just give, we encourage you to get involved. This is why for certain donations and wish lists, you can hear from the people who ultimately receive you help. We encourage you to keep the relationship going, and see how much the seeds you sowed have grown.</p>
      </section>
      <section>
        <h3>Be Real For Charity</h3>
        <p>Sometimes people encounter charity scams. This affects all legitimate charities and fundraisers worldwide because some people might hesitate to give due to trust issues. This is why here at Philippine Charities, we take pains in choosing the right charity partners to support.</p>
      </section>
    </Container>
  );
}

export default MissionScreen;
